// components
import { Header, Paragraph } from "components/atoms/Typography";

// helpers
import { getDisplayInfo } from "utils/formatting";

// css
import "../ByBuildingBarChart.css";
import { useTooltipDataContext } from "./hooks/useTooltipDataContext";

interface ByBuildingChartTooltipProps {
    currentDataIndex?: number;
}

function ByBuildingChartTooltip({ currentDataIndex }: ByBuildingChartTooltipProps) {
    if (currentDataIndex === undefined) return null;

    const { buckets } = useTooltipDataContext();
    const { buildings, average } = buckets[currentDataIndex];
    const { min: dataMin } = buckets[0];
    const { selectedKey } = buildings[0];

    const { formatFunction, unit } = getDisplayInfo(selectedKey, dataMin || 0);

    return (
        <div className="bar-tooltip">
            {buildings.length > 1 && (
                <div className="bar-tooltip--title">
                    <Header style={{ color: "var(--audette-gray-500)" }} size="small">
                        Average:
                    </Header>
                    <Paragraph>
                        {formatFunction ? formatFunction(average, false) : average} {unit}
                    </Paragraph>
                </div>
            )}
            {buildings.slice(0, 5).map((b) => (
                <div className="bar-tooltip--row" key={b.key}>
                    <Header size="x-small">{b.address}</Header>
                    <Paragraph size="small">{`${formatFunction ? formatFunction(b.value, false) : b.value} ${unit}`}</Paragraph>
                </div>
            ))}
        </div>
    );
}

export default ByBuildingChartTooltip;
